import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiReferencesService {

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'references');
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
   info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('references', id);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('references', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  referenceDataEdit(params: any): Observable<Res> {

    return this.api.post('reference_data/list', params, 'private');
  }
  
  // /**
  //  * 
  //  * @param id string
  //  * @returns Observable<Res>
  //  */
  //  edit(id: string): Observable<Res> {

  //   return this.apiBasic.edit('references', id);
  // }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
   update(params: any): Observable<Res> {

    return this.apiBasic.update('references', params);
  }

  /**
   * 
   */
   delete(params: any): Observable<Res> {

    return this.apiBasic.delete('references', params);
  }
}
